<template>
  <div ref="madeForm">
    <avue-form :option="optionForm" ref="form" v-model="formData"></avue-form>
    <FormTable ref="formTable" :formData="formData" :optionConfig="optionConfig" />
    <span slot="dialog_footer" class="dialog-footer" v-if="!isDetails()">
      <el-button icon="el-icon-circle-plus-outline" type="primary" @click="submitForm()" :disabled="loading">提交</el-button>
      <el-button icon="el-icon-circle-close" @click="$emit('handleClose')" :disabled="loading">取消</el-button>
    </span>
    <SelectPlan ref="selectPlan" @replace="replace"></SelectPlan>
  </div>
</template>

<script>
import { add, update, getDetail } from "../api";
import { disposeDetail, showItem, rulesInput } from '@/basic-common/util/common.js';
import SelectPlan from '@/views/railway-management/arrivalnoteplan/components/select-plan.vue';

const TRAIN_NUMBER_MAX_LEN = 30
const CARRIAGE_NO_MAX_LEN = 30
const REMARK_MAX_LEN = 200
const MAX_CARRIAGE_COUNT = 99999
const MAX_WEIGHT = 99999

export default {
  components: { SelectPlan },
  props: {
    transmitData: {
      required: true,
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data () {
    return {
      visible: false,
      title: '',
      show: false,
      loading: false,
      formData: {
        list: []
      },
      optionForm: {
        ...this.$store.state.formOption,
        submitBtn: false,
        emptyBtn: false,
        detail: this.isDetails(), //启用form详情样式
        column: [
          {
            label: '计划名称',
            prop: 'planName',
            // search: true, // 查询是否显示
            overHidden: true,
            allowCreate: true,
            maxlength: 30,
            readonly: true,
            rules: rulesInput(2),
            click: () => {
              this.$refs.selectPlan.open()
            },
          },
          {
            label: "货主",
            prop: "custNo",
            type: "select",
            remote: true,
            dicUrl: "/api/produce/blade-dept/select/distinct/select",
            rules: rulesInput(2),
            props: {
              label: "deptName",
              value: "id",
            },
          },
          {
            label: "车次编号",
            prop: "trainNumber",
            maxlength: TRAIN_NUMBER_MAX_LEN,
            showWordLimit: true,
            rules: rulesInput(1),
          },
          {
            label: "车厢数",
            prop: "carriageCount",
            type: "number",
            min: 1,
            max: MAX_CARRIAGE_COUNT,
            rules: rulesInput(1),
          },
          {
            label: "总重量(吨)",
            prop: "totalWeight",
            type: "number",
            precision: 2,
            min: 0.01,
            max: MAX_WEIGHT,
            rules: rulesInput(1),
          },
          {
            label: "合同名称",
            prop: "contractName",
            type: "select",
            remote: true,
            dicUrl:
              "/api/produce/transport-contract/select/distinct/pycode?contractName={{key}}",
            props: {
              label: "contractName",
              value: "id",
            },
          },
          {
            label: "到达时间",
            prop: "trainArrivalTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            rules: rulesInput(1),
          },
          {
            label: "发车时间",
            prop: "trainDepartTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            rules: rulesInput(1),
          },
        ]
      },
      list: [],
      optionConfig: {
        columnType: this.transmitData.type,
        addBtn: true,
        align: 'center',
        column: [{
          label: '车厢号',
          prop: 'carriageNo',
          required: true,
          bind: {
            maxlength: CARRIAGE_NO_MAX_LEN,
            showWordLimit: true,
          },
        },
        {
          label: '数量(吨)',
          prop: 'weight',
          type: 'custom-input',
          precision: 2,
          max: MAX_WEIGHT,
          required: true,
        },
        // {
        //   label: '称重方式',
        //   prop: 'weightType',
        //   type: 'select',
        //   commonDict: 'weightType',
        //   props: {
        //     label: "dictValue",
        //     value: "dictKey",
        //   },
        //   cell: true
        // },
        {
          label: '皮重(吨)',
          prop: 'tareWeight',
          type: 'custom-input',
          precision: 2,
          max: MAX_WEIGHT,
          required: true,
        }, {
          label: '毛重(吨)',
          prop: 'grossWeight',
          type: 'custom-input',
          precision: 2,
          max: MAX_WEIGHT,
          required: true,
        },
        // {
        //   label: '净重',
        //   prop: 'netWeight',
        //   type: 'custom-input',
        //   precision: 2,
        //   required: true,
        // }
    ]
      }
    }
  },
  created () {
    const { type, id } = this.transmitData
    type !== 'add' && this.getDetail(id)
  },
  methods: {
    toNumber (value) {
      if (value === null || value === undefined || value === '') return null
      const n = Number(value)
      return Number.isFinite(n) ? n : null
    },
    validateDateOrder () {
      const arrive = this.formData.trainArrivalTime
      const depart = this.formData.trainDepartTime
      if (!arrive || !depart) return true
      const a = new Date(String(arrive).replace(/-/g, '/'))
      const d = new Date(String(depart).replace(/-/g, '/'))
      if (Number.isNaN(a.getTime()) || Number.isNaN(d.getTime())) return true
      if (d < a) {
        this.$message.error('发车时间不能早于到达时间')
        return false
      }
      return true
    },
    validateMainFields () {
      const trainNumber = this.formData.trainNumber == null ? '' : String(this.formData.trainNumber).trim()
      if (trainNumber.length > TRAIN_NUMBER_MAX_LEN) {
        this.$message.error('车次编号不能超过' + TRAIN_NUMBER_MAX_LEN + '个字符')
        return false
      }
      const carriageCount = this.toNumber(this.formData.carriageCount)
      if (!Number.isInteger(carriageCount) || carriageCount < 1 || carriageCount > MAX_CARRIAGE_COUNT) {
        this.$message.error('车厢数必须是1-' + MAX_CARRIAGE_COUNT + '之间的整数')
        return false
      }
      const totalWeight = this.toNumber(this.formData.totalWeight)
      if (totalWeight == null || totalWeight <= 0 || totalWeight > MAX_WEIGHT) {
        this.$message.error('总重量必须大于0且不超过' + MAX_WEIGHT + '吨')
        return false
      }
      return this.validateDateOrder()
    },
    validateCarriageRows () {
      const list = this.formData.list || []
      const carriageCount = this.toNumber(this.formData.carriageCount)
      if (Number.isInteger(carriageCount) && list.length !== carriageCount) {
        this.$message.error('车厢明细数量必须与车厢数一致')
        return false
      }
      for (let i = 0; i < list.length; i++) {
        const row = list[i] || {}
        const prefix = '第' + (i + 1) + '行'
        const carriageNo = row.carriageNo == null ? '' : String(row.carriageNo).trim()
        if (!carriageNo) {
          this.$message.error(prefix + '车厢号不能为空')
          return false
        }
        if (carriageNo.length > CARRIAGE_NO_MAX_LEN) {
          this.$message.error(prefix + '车厢号不能超过' + CARRIAGE_NO_MAX_LEN + '个字符')
          return false
        }
        const weightFields = [
          { key: 'weight', label: '数量' },
          { key: 'tareWeight', label: '皮重' },
          { key: 'grossWeight', label: '毛重' },
        ]
        for (const item of weightFields) {
          const n = this.toNumber(row[item.key])
          if (n == null || n <= 0 || n > MAX_WEIGHT) {
            this.$message.error(prefix + item.label + '必须大于0且不超过' + MAX_WEIGHT + '吨')
            return false
          }
        }
        const tare = this.toNumber(row.tareWeight)
        const gross = this.toNumber(row.grossWeight)
        if (tare != null && gross != null && tare > gross) {
          this.$message.error(prefix + '皮重不能大于毛重')
          return false
        }
        const remark = row.remark == null ? '' : String(row.remark)
        if (remark.length > REMARK_MAX_LEN) {
          this.$message.error(prefix + '备注不能超过' + REMARK_MAX_LEN + '个字符')
          return false
        }
      }
      return true
    },
    validateBusinessRules () {
      return this.validateMainFields() && this.validateCarriageRows()
    },
    //提交
    async submitForm () {
      const list = this.formData.list
      const { type } = this.transmitData
      if (!list.length) {
        return this.$message.error('请录入表格数据并验证必填项')
      }
      const subFormValidate = await this.$refs.formTable.getValidate()
      this.$refs.form.validate((valid, done) => {
        if (valid && subFormValidate && this.validateBusinessRules()) {
          if (type == 'add') {
            add(this.formData).then(({ data }) => {
              this.$emit('handleClose', 'refresh')
              this.$message({
                type: 'success',
                message: data.msg,
              })
              done()
            })
          } else {
            update(this.formData).then(({ data }) => {
              this.$emit('handleClose', 'refresh')
              this.$message({
                type: 'success',
                message: data.msg,
              })
              done()
            })
          }
        } else {
          done()
          this.$message.error('错误, 请验证必填项并录入符合规则的数据')
        }
      })
    },
    // 回显信息初始化
    getDetail (id) {
      this.loading = true
      getDetail(id).then(res => {
        this.formData = res.data.data
        // 特殊处理详情 主表和子表， 禁用问题，悬浮提示问题。
        const topTier = this.$refs.madeForm
        this.isDetails() && disposeDetail(topTier)
        this.isDetails() && disposeDetail(topTier, 'table-details')
      }).finally(() => {
        this.loading = false
      })

    },
    // 是否是详情
    isDetails () {
      return this.transmitData.type && this.transmitData.type == 'view'
    },
    replace (row) {
      const replaceKey = ['planNo', 'planName', 'custNo', 'trainNumber', 'cargoName', 'cargoNo', 'contractName', 'contractNo']
      replaceKey.forEach(item => {
        this.$set(this.formData, item, row[item])
      });
    }
  }
}
</script>
<style scoped lang="scss"></style>
